/** Format a time value (ISO string or "HH:MM[:SS]") to "H:MM AM/PM". UTC-aware for ISO values. */
export function formatTime(time?: string | null): string | null {
	if (!time) return null;
	let h: number;
	let m: number;
	if (time.includes("T")) {
		const d = new Date(time);
		if (Number.isNaN(d.getTime())) return null;
		h = d.getUTCHours();
		m = d.getUTCMinutes();
	} else {
		const [hStr, mStr] = time.split(":");
		h = parseInt(hStr, 10);
		m = parseInt(mStr, 10);
		if (Number.isNaN(h) || Number.isNaN(m)) return null;
	}
	const period = h >= 12 ? "PM" : "AM";
	const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
	return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
}
